import { Shimmer } from '@components';

import { Container, ContainerLoadMore } from '../ListProducts.styles';

const ListProductsLoading = () => {
  return (
    <Container>
      <div style={{ height: 16 }} />
      <Shimmer
        style={{ height: 48, width: '100%', borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />

      <div style={{ height: 16 }} />
      <Shimmer
        style={{ height: 48, width: '100%', borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />

      <div style={{ height: 16 }} />
      <Shimmer
        style={{ height: 48, width: '100%', borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
    </Container>
  );
};

const ListProductsLoadingRows = (props: { height?: number }) => {
  const { height = 46 } = props;
  return (
    <ContainerLoadMore>
      <Shimmer
        style={{ height, width: '100%', borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{ height, width: '100%', borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{ height, width: '100%', borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
    </ContainerLoadMore>
  );
};

export { ListProductsLoading, ListProductsLoadingRows };
